export default __webpack_public_path__ + "2e7b01942021ff8be164fa7aac29d108.svg";